module.exports = __webpack_public_path__ + "media/images/flags/64/French-Polynesia-1fe056728fedb2b21b1c9123727e500f.png";